import { BaseLayoutFactory } from '../../../components/base-layout-factory';
import { PurchaseCreateEditProvider } from './context/purchase-create-edit-context';
import { PurchaseCreateEditComponent } from './purchase-create-edit-component';

export function PurchaseCreateEditFactory() {
    return (
        <BaseLayoutFactory>
            <PurchaseCreateEditProvider>
                <PurchaseCreateEditComponent />
            </PurchaseCreateEditProvider>
        </BaseLayoutFactory>
    );
}
